import { CopyButton } from "@/components/ui/CopyButton";
import { Stack, Typography, TypographyVariant } from "@mui/material";

type Props = {
  label: string;
  text: string | null | undefined;
  copyable?: boolean;
  variant?: TypographyVariant;
};

const SPACING = 1;

export function LabeledText({
  label,
  text,
  copyable = false,
  variant = "body1",
}: Props) {
  return (
    <Stack direction="row" gap={SPACING} justifyContent={"space-between"}>
      <Typography color="textSecondary" variant={variant}>
        {label + ":"}
      </Typography>
      <CopyButton
        text={copyable && text ? text : ""}
        sx={{
          maxWidth: (theme) => `calc(66% - ${theme.spacing(SPACING / 2)})`,
        }}
      >
        <Typography color="text" variant={variant}>
          {text || "—"}
        </Typography>
        {/* this is an em dash, not a hyphen */}
      </CopyButton>
    </Stack>
  );
}
